/**
 * @generated SignedSource<<59fd0630c8e43f209ba8fb52443d1454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MonitoringStandardsGradesQuery$variables = Record<PropertyKey, never>;
export type MonitoringStandardsGradesQuery$data = {
  readonly standardGrades: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
  }>;
};
export type MonitoringStandardsGradesQuery = {
  response: MonitoringStandardsGradesQuery$data;
  variables: MonitoringStandardsGradesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StandardGradeNode",
    "kind": "LinkedField",
    "name": "standardGrades",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MonitoringStandardsGradesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MonitoringStandardsGradesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "66618635885475d1e092cd99486555b6",
    "id": null,
    "metadata": {},
    "name": "MonitoringStandardsGradesQuery",
    "operationKind": "query",
    "text": "query MonitoringStandardsGradesQuery {\n  standardGrades {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "482e6a0d6f32aefacad57b2dead473e9";

export default node;
